/**
 * Resolve a path that lives in /public against Vite's configured base URL,
 * so assets keep working whether the site is served from the domain root
 * (lorddarthart.github.io) or a project subpath.
 */
export function asset(path: string): string {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  const clean = path.replace(/^\//, "");
  return `${base}/${clean}`;
}
